module.exports = __webpack_public_path__ + "static/media/oberflex-aniegre-2560x1440.b41b86bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegre-2560x1440.jpg
// module id = 973
// module chunks = 37